module.exports = __webpack_public_path__ + "img/f280-reports.f4056af6.jpg";